import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList, serchSelect } from "@/mixins/index";
import addDownUrl from "./components/addDownUrl";
export default {
  name: "officePackage",
  mixins: [loadMoreList, serchSelect],
  components: {
    addDownUrl: addDownUrl
  },
  data: function data() {
    return {
      pagingReqFn: "offWebPkgConfigIndex",
      pagingReqValue: "",
      paramsData: {
        id: '',
        name: '',
        language: '',
        platform_type: ''
      }
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'offWebPkgConfigDestroy',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    }
  }
};